import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";

import { TokenReleaseComponent } from "./token-release.component";
import { TokenReleaseLayoutComponent } from "./token-release.layout";

export const routes: Routes = [
    {
        path: "",
        component: TokenReleaseLayoutComponent,
        children: [
            {
                path: "",
                component: TokenReleaseComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TokenReleaseRoutingModule {}
